import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface UseKeyboardNavigationProps {
  versions: { number: number }[];
  activeVersionNumber: number | null;
  navigateToVersionLink: (versionNumber: number) => string;
}

const useKeyboardNavigation = ({
  versions,
  activeVersionNumber,
  navigateToVersionLink,
}: UseKeyboardNavigationProps) => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (
        e.target instanceof HTMLInputElement ||
        e.target instanceof HTMLTextAreaElement
      ) {
        return;
      }

      if (!versions.length || activeVersionNumber === null) return;

      if (e.key === "j" && activeVersionNumber <= versions.length - 1) {
        e.preventDefault();
        navigate(navigateToVersionLink(activeVersionNumber + 1));
      } else if (e.key === "k" && activeVersionNumber - 1 > 0) {
        e.preventDefault();
        navigate(navigateToVersionLink(activeVersionNumber - 1));
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [versions, navigate, navigateToVersionLink, activeVersionNumber]);
};

export default useKeyboardNavigation;
